module.exports = __webpack_public_path__ + "static/object-detector-aerial-demo-17470eeee1a4f099a95dd67fc602b72c.jpg";